







































































































import Vue from 'vue';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus/event-bus';
import { dialogMaxWidth } from '@/constants';
import { PageSidebar } from '@/components/page-components';
import { ConstructPhoneNumber } from '@/helpers';
import { MemberPreferenceInformationResponseModel, UserModel, MemberPersonalInformationResponseModel, MemberCustomerServiceInfoResponseModel } from '@/@types/member';

interface Data {
  memberPreferenceInformation: MemberPreferenceInformationResponseModel;
  memberPreferenceInformationClone: MemberPreferenceInformationResponseModel;
  formHasChanges: boolean;
  isLoading: boolean;
  editing: boolean;
  showConfirmModal: boolean;
  dialogMaxWidth: string;
  showSuccessMessage: boolean;
}

export default Vue.extend({
  name: 'Communications',
  beforeRouteEnter(to, from, next) {
    const promises = [store.dispatch('getMemberPreferenceInformation')];
    return LoadingService.watchPromises(promises)
      .then(next)
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      memberPreferenceInformation: null,
      memberPreferenceInformationClone: null,
      formHasChanges: false,
      isLoading: null,
      editing: false,
      showConfirmModal: false,
      dialogMaxWidth,
      showSuccessMessage: false,
    };
  },
  watch: {
    'memberPreferenceInformation.emailIndicator'(): void {
      this.formHasChanges = this.formDirtyCheck();
    },
    'memberPreferenceInformation.textIndicator'(): void {
      this.formHasChanges = this.formDirtyCheck();
    },
  },
  beforeMount() {
    this.memberPreferenceInformation = this.$store.getters.memberPreferenceInformation;
    this.memberPreferenceInformationClone = JSON.parse(
      JSON.stringify(this.memberPreferenceInformation),
    );
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
    primaryPhone(): string {
      return ConstructPhoneNumber(this.personalInformation.primaryPhone);
    },
    alternatePhone(): string {
      return ConstructPhoneNumber(this.personalInformation.alternatePhone);
    },
    displayAlternatePhoneNumber(): boolean {
      return !this.personalInformation.isMobilePrimary && this.personalInformation.isMobileAlternate;
    },
    displayAddPhoneNumber(): boolean {
      return !this.personalInformation.isMobilePrimary && !this.personalInformation.isMobileAlternate;
    },
    customerServiceInfo(): MemberCustomerServiceInfoResponseModel {
      return this.$store.getters.customerServiceInformation;
    },
  },
  methods: {
    formDirtyCheck(): boolean {
      const clonedTextIndicator = this.memberPreferenceInformationClone
          .textIndicator,
        clonedEmailIndicator = this.memberPreferenceInformationClone
          .emailIndicator,
        emailIndicator = this.memberPreferenceInformation.emailIndicator,
        textIndicator = this.memberPreferenceInformation.textIndicator;

      return (
        clonedEmailIndicator !== emailIndicator ||
        clonedTextIndicator !== textIndicator
      );
    },
    revertForm(): void {
      this.editing = false;
      this.showConfirmModal = false;
      this.memberPreferenceInformation = JSON.parse(
        JSON.stringify(this.memberPreferenceInformationClone),
      );
    },
    cancelEdit(): void {
      if (this.formHasChanges) {
        this.showConfirmModal = true;
      } else {
        this.revertForm();
      }
    },
    toggleEdit(): void {
      this.editing = true;
    },
    updatePreferences(): void {
      this.isLoading = true;
      this.$store
        .dispatch('updateMemberSMSCommunication', {
          memberKey: this.user.memberId,
          ...this.memberPreferenceInformation,
        })
        .then(() => {
          this.editing = false;
          this.formHasChanges = false;
          this.isLoading = false;
          this.memberPreferenceInformationClone = JSON.parse(
            JSON.stringify(this.memberPreferenceInformation),
          );
          this.showSuccessMessage = true;

          // GTM Event - Update Communication Preferences
          window.dataLayer.push({
            event: 'communicationPreferences',
          });

          setTimeout(() => {
            this.showSuccessMessage = false;
          }, 2000);
        })
        .catch(() => {
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
          });
          this.editing = false;
          this.formHasChanges = false;
          this.isLoading = false;
        });
    },
  },
  components: {
    PageSidebar,
  },
});
